module.exports = __webpack_public_path__ + "static/media/en.fa6ad4bf.svg";